<template>
  <div>
    <el-dialog
      title="表单协作人员"
      :visible.sync="value.visible"
      width="700px"
      :destroy-on-close="true"
      @open="onDlgOpen"
    >
      <el-alert
        type="info"
        description="【属主】管理表单权限；【协管】管理表单数据权限"
        show-icon
        :closable="false"
        class="mb-2_5"
      />
      <div v-loading="$store.state.app.loadingList.includes('listFormUser')">
        <div class="my-2_5 row-wrap">
          <div class="grow">{{ list.items? list.items.length : 0 }} 位协作人员</div>

          <el-button v-show="params.isAdmin" size="small" type="primary" plain @click="onOpenDlgMemList">
            <span class="iconfont icon-adduser" /> 工作区
          </el-button>

          <el-button v-show="params.isAdmin" size="small" type="default" plain @click="onAddFormUser">
            <span class="iconfont icon-adduser" /> 公海
          </el-button>
        </div>

        <div>
          <div v-if="list.items && list.items.length <= 0" class="has-bg-white border-radius-bottom-m has-text-light text-center py-2_5 px-4"><el-empty :image-size="100" description="暂无数据" /></div>

          <div v-if="list.items && list.items.length > 0">
            <div v-for="(item, index) in list.items" :key="item.id.toString()" class="has-bg-white border-t row-wrap py-2_5 px-4">
              <div class="grow py-2_5">
                <div class="is-fs-l">
                  <!-- <span class="iconfont icon-file-text" /> -->
                  <span class="mr-2">{{ item.user.nickname }}</span>
                  <el-tag v-if="item.role === 1" type="primary" size="mini" class="mr-1">属主</el-tag>
                  <el-tag v-if="item.role === 2" type="warning" size="mini" class="mr-1">协管</el-tag>
                  <el-tag v-if="item.is_external" type="info" size="mini" class="mr-1">外部</el-tag>
                </div>
              </div>

              <div v-show="params.isAdmin" @click.stop>
                <el-button v-show="!item.is_external" type="text" @click="onItemSetRole(item)">权限</el-button>
                <el-button :loading="$store.state.app.loadingList.includes('delFormUser')" type="text" @click="onItemDel(item, index)">移除</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4">
          <!-- <el-button @click="onCancel">取 消</el-button>
          <el-button type="primary" @click="onOk">确 定</el-button> -->
        </div>
      </div>
    </el-dialog>
    <DlgAddFormUser v-model="dlgAddFormUser.val" :params="dlgAddFormUser.params" @ok="onDlgAddFormUserOk" />
    <DlgSetFormUser v-model="dlgSetFormUser.val" :params="dlgSetFormUser.params" @ok="onDlgSetFormUserOk" />
    <DlgMemList v-model="dlgMemList.val" :params="dlgMemList.params" @closed="onDlgMemListClosed" />
  </div>
</template>

<script>
import { listFormUser, delFormUser } from '@/api/form'
import DlgAddFormUser from '@/components/DlgAddFormUser.vue'
import DlgSetFormUser from '@/components/DlgSetFormUser.vue'
import DlgMemList from '@/components/DlgMemList.vue'

export default {
  name: 'DlgFormUser',
  components: {
    DlgAddFormUser,
    DlgSetFormUser,
    DlgMemList
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        visible: false
        // item: {}
      })
    },
    params: {
      type: Object,
      default: () => ({
        formId: 0,
        isAdmin: false
      })
    }
  },
  emits: ['ok', 'cancel'],
  data() {
    return {
      list: {},

      role: [{
        value: '1',
        label: '属主'
      }, {
        value: '2',
        label: '协管'
      }],
      dlgSetFormUser: {
        val: {
          visible: false
        },
        params: {
          item: null
        }
      },
      dlgAddFormUser: {
        val: {
          visible: false
        },
        params: {
          formId: 0
        }
      },
      dlgMemList: {
        val: {
          visible: false
        },
        params: {
          formId: 0,
          excludeUserIds: []
        }
      }
    }
  },
  computed: {
    dataQuery() {
      const q = `?id=${this.params.formId}&expand=user`
      return q
    }
  },
  watch: {
  },
  created() {
  },
  mounted() {
    console.log(this.value)
  },

  methods: {
    async fetchData(query) {
      const data = await listFormUser({
        query: query
      }, 'listFormUser')
      console.log(data)
      this.list = data
    },

    async onDlgOpen() {
      this.isChanged = false
      this.fetchData(this.dataQuery)
    },

    onAddFormUser() {
      const that = this
      that.dlgAddFormUser.val.visible = true
      that.dlgAddFormUser.params.formId = that.params.formId
    },
    onDlgAddFormUserOk() {
      this.fetchData(this.dataQuery)
    },
    onSetFormUser() {
      const that = this
      that.dlgSetFormUser.val.visible = true
    },
    onDlgSetFormUserOk() {
      this.fetchData(this.dataQuery)
    },
    onItemSetRole(item) {
      this.dlgSetFormUser.val.visible = true
      this.dlgSetFormUser.params.item = item
    },

    onOpenDlgMemList() {
      const that = this
      that.dlgMemList.val.visible = true
      that.dlgMemList.params.formId = that.params.formId
      that.dlgMemList.params.excludeUserIds = []
      if (that.list.items) {
        that.list.items.forEach(element => {
          that.dlgMemList.params.excludeUserIds.push(element.user_id.toString())
        })
      }
    },
    onDlgMemListClosed(isChanged) {
      if (isChanged) this.fetchData(this.dataQuery)
    },

    onCancel() {
      console.log('cancel')
      this.value.visible = false
      this.$emit('cancel')
    },
    async onOk() {
      // const that = this
      console.log('ok')
      // await this.$refs['dlgForm'].validate(async(valid, fields) => {
      //   if (valid) {
      //     this.value.visible = false
      //     await that.saveAppForm()
      //     that.$emit('ok', this.value)
      //   } else {
      //     console.log('error submit!', fields)
      //   }
      // })
    },

    onItemDel(item, index) {
      const that = this
      that.$confirm('确认要删除？', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const res = await delFormUser({
          query: `?form_id=${item.form_id}&user_id=${item.user_id}`
        }, 'delFormUser')
        console.log(res)

        that.list.items.splice(index, 1)
        that.$message({
          message: '操作成功',
          type: 'success',
          center: true
        })
      }).catch(() => {})
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>
